import React,  { Fragment } from 'react'
import PropTypes from 'prop-types'
import { BaseComponent, Icon } from 'belle-js'
import DocumentListHeaders from './DocumentListHeaders'
import DocumentListItem from './DocumentListItem'
import NoDocuments from './NoDocuments'
import styles from './DocumentList.module.scss'
import {
  documentTabConfig,
  findTabConfig,
} from 'utils/Client/documents'
import PrivateWealthEmailLink from 'components/Shared/PrivateWealthEmailLink/PrivateWealthEmailLink'

class DocumentList extends BaseComponent {

  constructor (props) {
    super(props)
    this.state = { downloadError: null }
    this.bind('onDownloadError', 'handleCloseErrorNotification')
  }

  onDownloadError (fileName) {
    const message = (
      <Fragment>
        <p>
        Oops — that file’s been removed.
        Your team has removed that document.
        Refresh the page to see your available documents.
        If you have questions or need to retrieve an older file, please <PrivateWealthEmailLink message="let your team know" />
        and we’ll help.
        </p>
      </Fragment>
    )

    this.setState({ downloadError: message })
  }

  getFilterTitle (documentType) {
    return findTabConfig('label', documentType).title || ''
  }

  handleCloseErrorNotification () {
    this.setState({ downloadError: null })
  }

  render () {
    const { documents, documentType, isMobile, shouldRenderSubFolderHeader } = this.props
    const { downloadError } = this.state

    return (
      <div className={styles.DocumentList}>
        {downloadError &&
          <div className={styles.errorContainer}>
            <button type="button" onClick={this.handleCloseErrorNotification}>
              <Icon icon="close_15" />
            </button>
            {downloadError}
          </div>
        }
        { shouldRenderSubFolderHeader &&
          <p className={styles.filterTitle}>{this.getFilterTitle(documentType)}</p> }
        { documents.length > 0 &&
          <DocumentListHeaders
            documentType={documentType}
            data-test-id="document-list-headers" />
        }
        { documents.length > 0 ? (
          documents.map((document, i) => (
            <DocumentListItem
              key={i}
              data-test-id="document-list-item"
              document={document}
              documentType={documentType}
              handleDownloadError={this.onDownloadError}
              isMobile={isMobile} />
          ))
        ) : (
          <NoDocuments
            data-test-id="no-documents"
            documentType={documentType} />
        )}
      </div>
    )
  }

}

DocumentList.defaultProps = {
  documents: [],
  documentType: documentTabConfig.myUploads.label,
  isMobile: false
}

DocumentList.propTypes = {
  documents: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
  })),
  documentType: PropTypes.string,
  isMobile: PropTypes.bool,
  shouldRenderSubFolderHeader: PropTypes.bool,
}

export default DocumentList



// WEBPACK FOOTER //
// ./src/components/Client/DocumentList/DocumentList.jsx